import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getListingAgencies, getListingRealtors } from '../../../../actions/filters';
import { getLocationsIfEmpty } from '../../../../actions/geo/getLocationsIfEmpty';
import { setRegion } from '../../../../actions/geo/setRegion';
import { getRegion } from '../../../../selectors/filters/getRegion';
import { getCurrentTab } from '../../../../selectors/tabs';
import { ILocation } from '../../../../types/location';
import { ETabs } from '../../../../types/redux/tabs';
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch';

export const useGeoLocationFilter = () => {
  const dispatch = useAppDispatch();
  const selectedRegion = useSelector(getRegion);
  const currentTab = useSelector(getCurrentTab);
  const [isModalOpen, setIsModalOpen] = useState(false);

  /** При маунте загружаем список популярных регионов, что бы не делать это при открытии **/
  useEffect(() => {
    dispatch(getLocationsIfEmpty());
  }, [dispatch]);

  const handleSelectRegion = useCallback(
    (region: ILocation) => {
      const isRealtorsListing = currentTab === ETabs.Realtors;
      const getListing = isRealtorsListing ? getListingRealtors : getListingAgencies;

      setIsModalOpen(false);

      dispatch(getListing(setRegion, region));
    },
    [dispatch, currentTab],
  );

  const handleOpen = useCallback(() => setIsModalOpen(true), []);
  const handleClose = useCallback(() => setIsModalOpen(false), []);

  return {
    selectedRegion,
    isModalOpen,
    handleSelectRegion,
    handleOpen,
    handleClose,
  };
};
